import { createContext, useContext } from 'react';
import type { KiCodeOpenArgs, KiCodeTarget } from './profiles';

export interface KiCodeApi {
  open: (args: KiCodeOpenArgs) => void;
  close: () => void;
  session: KiCodeTarget | null;
  available: boolean;
}

const noop = () => {};

export const KiCodeContext = createContext<KiCodeApi>({
  open: noop,
  close: noop,
  session: null,
  available: false,
});

export const useKiCode = (): KiCodeApi => useContext(KiCodeContext);

/** Just what launch callers need; changes only when availability flips. */
export interface KiCodeLauncher {
  /** Resolves true once KiCode opens, false if a busy surface's prompt is cancelled. */
  open: (args: KiCodeOpenArgs) => Promise<boolean>;
  available: boolean;
}

export const KiCodeLauncherContext = createContext<KiCodeLauncher>({
  open: () => Promise.resolve(false),
  available: false,
});

export const useKiCodeLauncher = (): KiCodeLauncher =>
  useContext(KiCodeLauncherContext);
